import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GalleryContainerComponent } from './components/gallery-container/gallery-container.component';
import { GalleryFiltersLoftComponent } from './components/gallery-filters-loft/gallery-filters-loft.component';
import { GalleryResultsComponent } from './components/gallery-results/gallery-results.component';
import { ButtonsModule } from '../shared/components/buttons/buttons.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxsModule } from '@ngxs/store';
import { GalleryState } from './state/gallery.state';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { DirectivesModule } from '../shared/directives/directives.module';
import { ProgressIndictatorsModule } from '../shared/components/progress-indicators/progress-indicators.module';
import { ListModule } from '../shared/components/list/list.module';
import { GalleryCardComponent } from './components/gallery-cards/gallery-card/gallery-card.component';
import { GalleryCardsComponent } from './components/gallery-cards/gallery-cards/gallery-cards.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SharedModule } from '../shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GalleryViewModeComponent } from './components/gallery-view-mode/gallery-view-mode.component';
import { GalleryCategoriesComponent } from './components/gallery-categories/gallery-categories.component';
import { GalleryBannerComponent } from './components/gallery-banner/gallery-banner.component';
import { GalleryCollectionsComponent } from './components/gallery-collections/gallery-collections.component';
import { GalleryTitleComponent } from './components/gallery-title/gallery-title.component';
import { MaterialModule } from '../material.module';
import { GalleryHeaderComponent } from './components/gallery-header/gallery-header.component';
import { GalleryPaginationComponent } from './components/gallery-pagination/gallery-pagination.component';
import { GalleryBulkActionsComponent } from './components/gallery-bulk-actions/gallery-bulk-actions.component';
import { GalleryClientsComponent } from './components/gallery-clients/gallery-clients.component';
import { RouterModule } from '@angular/router';
import { NavigationModule } from '../shared/components/navigation/navigation.module';
import { GallerySourceComponent } from './components/gallery-source/gallery-source.component';
import { GalleryTagsSingleComponent } from './components/gallery-tags-single/gallery-tags-single.component';

@NgModule({
  declarations: [
    GalleryContainerComponent,
    GalleryFiltersLoftComponent,
    GalleryResultsComponent,
    GalleryCardComponent,
    GalleryCardsComponent,
    GalleryViewModeComponent,
    GalleryCategoriesComponent,
    GalleryBannerComponent,
    GalleryCollectionsComponent,
    GalleryTitleComponent,
    GalleryHeaderComponent,
    GalleryPaginationComponent,
    GalleryBulkActionsComponent,
    GalleryClientsComponent,
    GallerySourceComponent,
    GalleryTagsSingleComponent
  ],
  imports: [
    NgxsModule.forFeature([
      GalleryState
    ]),
    // Lazy Load Images
    LazyLoadImageModule,
    RouterModule,
    ButtonsModule,
    CommonModule,
    ReactiveFormsModule,
    BookmarksModule,
    DirectivesModule,
    ListModule,
    MaterialModule,
    NavigationModule,
    ProgressIndictatorsModule,
    SharedModule,

    MatCheckboxModule
  ],
  exports: [
    GalleryContainerComponent,
    GalleryFiltersLoftComponent,
    GalleryResultsComponent,
    GalleryCardComponent,
    GalleryCardsComponent,
    GalleryViewModeComponent,
    GalleryTitleComponent
  ],
  entryComponents: [
    GalleryContainerComponent
  ]
})
export class GalleryModule { }
